module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/feed-add-c39449a2f63f322138c2d96b91ef7025.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/feed-add.svg
// module id = FgXS
// module chunks = 24